'use client';

import { CollectionType } from '@/@types';
import { Breadcrumbs } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import { useLocalizedLinks } from '@/components/core/hooks';

const ProfileBreadcrumbs: UIComponent<{ collection: CollectionType }> = ({ collection, children }) => {
  const links = useLocalizedLinks();
  return (
    <Breadcrumbs>
      {collection?.owner?.level && (
        <Breadcrumbs.Item href={links.users.explore(collection.owner.level!.name)}>{collection.owner.level.name}</Breadcrumbs.Item>
      )}
      {collection.owner && <Breadcrumbs.Item href={links.profile(collection.owner).root}>{collection.owner.nickname}</Breadcrumbs.Item>}
      <Breadcrumbs.Item>{collection.name}</Breadcrumbs.Item>
      {children}
    </Breadcrumbs>
  );
};

export default ProfileBreadcrumbs;
